import React, { useCallback } from 'react';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { history } from 'nallian-shared-ui/lib/config/history';
import updateAppService from '../services/updateAppService';
import AppForm from './AppForm';

const EditApp = ({ open, dispatchUpdateAppPut, updateAppFetch, appFetch }) => {
  const { id } = useParams();
  const { t } = useTranslation();

  const handleSubmit = useCallback(
    body => {
      dispatchUpdateAppPut(id, body, () => history.push(`/apps/${id}/details`), t);
    },
    [id, dispatchUpdateAppPut, t]
  );

  if (!open) return null;

  return (
    <AppForm
      editMode
      header={appFetch.value?.name}
      onSubmit={handleSubmit}
      submitProcessing={updateAppFetch.pending}
      returnRoute={`/apps/${id}/details`}
      cancelRoute={`/apps/${id}/details`}
      dataLoading={appFetch.pending}
      data={!appFetch.pending && appFetch.value}
    />
  );
};

EditApp.propTypes = {
  dispatchUpdateAppPut: PropTypes.func.isRequired,
  updateAppFetch: PropTypes.object.isRequired,
  appFetch: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

EditApp.defaultProps = { open: false };

export default updateAppService(EditApp);
